export const LOGO_SRC = "/images/logo_blanco.png";
